<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      d="M12.707.293a1,1,0,0,0-1.414,0l-11,11A1,1,0,0,0,1,13H2.25a.25.25,0,0,1,.25.25V23a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V18a2,2,0,0,1,4,0v5a1,1,0,0,0,1,1h5.5a1,1,0,0,0,1-1V13.25a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,.707-1.707Zm7.538,10.366a.25.25,0,0,1-.092.412A.972.972,0,0,0,19.5,12v9.75a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V18a4,4,0,0,0-8,0v3.75a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V12a.97.97,0,0,0-.653-.929.25.25,0,0,1-.092-.412l8.068-8.068a.25.25,0,0,1,.354,0Z"
    />
  </svg>
</template>
